import { BOARD_CODE } from ".";

export const BOARD_PERMISSION = {
  ACCESS: "access",
  READ: "read",
  WRITE: "write",
};

export const NON_MEMBER_PERMISSIONS = {
  [BOARD_CODE.NOTICE]: {
    [BOARD_PERMISSION.ACCESS]: true,
    [BOARD_PERMISSION.READ]: true,
    [BOARD_PERMISSION.WRITE]: false,
  },
  [BOARD_CODE.ANNUAL_REPORT]: {
    [BOARD_PERMISSION.ACCESS]: true,
    [BOARD_PERMISSION.READ]: true,
    [BOARD_PERMISSION.WRITE]: false,
  },
  [BOARD_CODE.FAQ]: {
    [BOARD_PERMISSION.ACCESS]: true,
    [BOARD_PERMISSION.READ]: true,
    [BOARD_PERMISSION.WRITE]: false,
  },
  [BOARD_CODE.BABY_CHEER]: {
    [BOARD_PERMISSION.ACCESS]: true,
    [BOARD_PERMISSION.READ]: true,
    [BOARD_PERMISSION.WRITE]: true,
  },
  [BOARD_CODE.CARE_CHEER]: {
    [BOARD_PERMISSION.ACCESS]: true,
    [BOARD_PERMISSION.READ]: true,
    [BOARD_PERMISSION.WRITE]: true,
  },
  [BOARD_CODE.BABY_MEMORIAL]: {
    [BOARD_PERMISSION.ACCESS]: true,
    [BOARD_PERMISSION.READ]: true,
    [BOARD_PERMISSION.WRITE]: true,
  },
  [BOARD_CODE.GENERAL_RESOURCE]: {
    [BOARD_PERMISSION.ACCESS]: true,
    [BOARD_PERMISSION.READ]: true,
    [BOARD_PERMISSION.WRITE]: false,
  },
  [BOARD_CODE.QUESTION]: {
    [BOARD_PERMISSION.ACCESS]: true,
    [BOARD_PERMISSION.READ]: true,
    [BOARD_PERMISSION.WRITE]: true,
  },
  [BOARD_CODE.CONTACT]: {
    [BOARD_PERMISSION.ACCESS]: true,
    [BOARD_PERMISSION.READ]: false,
    [BOARD_PERMISSION.WRITE]: true,
  },
};
